/** Supported language codes */
export type LanguageCode =
  | 'en' | 'es' | 'fr' | 'de' | 'pt' | 'it' | 'nl'
  | 'ru' | 'zh' | 'ja' | 'ko' | 'ar' | 'hi' | 'tr'
  | 'pl' | 'vi' | 'th' | 'id' | 'uk' | 'cs'
  | 'bg' | 'hr' | 'da' | 'et' | 'fi' | 'el'
  | 'hu' | 'ga' | 'lv' | 'lt' | 'mt' | 'ro'
  | 'sk' | 'sl' | 'sv'
  | 'ur' | 'fa'
  | 'bn' | 'ta' | 'te' | 'mr' | 'gu' | 'kn' | 'ml';

export interface LanguageInfo {
  code: LanguageCode;
  /** Native name displayed in language picker */
  name: string;
  /** English name for accessibility */
  english: string;
}

export const LANGUAGES: LanguageInfo[] = [
  { code: 'en', name: 'English', english: 'English' },
  { code: 'es', name: 'Español', english: 'Spanish' },
  { code: 'fr', name: 'Français', english: 'French' },
  { code: 'de', name: 'Deutsch', english: 'German' },
  { code: 'pt', name: 'Português', english: 'Portuguese' },
  { code: 'it', name: 'Italiano', english: 'Italian' },
  { code: 'nl', name: 'Nederlands', english: 'Dutch' },
  { code: 'ru', name: 'Русский', english: 'Russian' },
  { code: 'zh', name: '中文', english: 'Chinese' },
  { code: 'ja', name: '日本語', english: 'Japanese' },
  { code: 'ko', name: '한국어', english: 'Korean' },
  { code: 'ar', name: 'العربية', english: 'Arabic' },
  { code: 'hi', name: 'हिन्दी', english: 'Hindi' },
  { code: 'tr', name: 'Türkçe', english: 'Turkish' },
  { code: 'pl', name: 'Polski', english: 'Polish' },
  { code: 'vi', name: 'Tiếng Việt', english: 'Vietnamese' },
  { code: 'th', name: 'ไทย', english: 'Thai' },
  { code: 'id', name: 'Bahasa Indonesia', english: 'Indonesian' },
  { code: 'uk', name: 'Українська', english: 'Ukrainian' },
  { code: 'cs', name: 'Čeština', english: 'Czech' },
  { code: 'bg', name: 'Български', english: 'Bulgarian' },
  { code: 'hr', name: 'Hrvatski', english: 'Croatian' },
  { code: 'da', name: 'Dansk', english: 'Danish' },
  { code: 'et', name: 'Eesti', english: 'Estonian' },
  { code: 'fi', name: 'Suomi', english: 'Finnish' },
  { code: 'el', name: 'Ελληνικά', english: 'Greek' },
  { code: 'hu', name: 'Magyar', english: 'Hungarian' },
  { code: 'ga', name: 'Gaeilge', english: 'Irish' },
  { code: 'lv', name: 'Latviešu', english: 'Latvian' },
  { code: 'lt', name: 'Lietuvių', english: 'Lithuanian' },
  { code: 'mt', name: 'Malti', english: 'Maltese' },
  { code: 'ro', name: 'Română', english: 'Romanian' },
  { code: 'sk', name: 'Slovenčina', english: 'Slovak' },
  { code: 'sl', name: 'Slovenščina', english: 'Slovenian' },
  { code: 'sv', name: 'Svenska', english: 'Swedish' },
  { code: 'ur', name: 'اردو', english: 'Urdu' },
  { code: 'fa', name: 'فارسی', english: 'Persian' },
  { code: 'bn', name: 'বাংলা', english: 'Bengali' },
  { code: 'ta', name: 'தமிழ்', english: 'Tamil' },
  { code: 'te', name: 'తెలుగు', english: 'Telugu' },
  { code: 'mr', name: 'मराठी', english: 'Marathi' },
  { code: 'gu', name: 'ગુજરાતી', english: 'Gujarati' },
  { code: 'kn', name: 'ಕನ್ನಡ', english: 'Kannada' },
  { code: 'ml', name: 'മലയാളം', english: 'Malayalam' },
];
